import { initAnimationsForElement } from '../utils/animations.js';
import { trackGenerateLead } from '../utils/analytics.js';

const STEP_COUNT = 3;

const STEP_TITLES = {
	1: 'What you need help with',
	2: 'Budget and scale',
	3: 'Your details',
};

function validateStepFields(step) {
	const fields = step.querySelectorAll('input, select, textarea');

	for (const field of fields) {
		if (!field.checkValidity()) {
			field.reportValidity();
			field.focus({ preventScroll: true });
			return false;
		}
	}

	return true;
}

function bindFormLeadTracking(form) {
	form.addEventListener('submit', () => {
		const inquiryType = form.querySelector('[name="Inquiry type"]')?.value;

		trackGenerateLead({
			lead_source: 'contact_form',
			form_name: form.getAttribute('toolname') ?? 'contact',
			inquiry_type: inquiryType || undefined,
		});
	});
}

function initContactForm(form) {
	bindFormLeadTracking(form);

	if (form.dataset.contactFormMode === 'full') return;

	initProgressiveContactForm(form);
}

function initProgressiveContactForm(form) {
	const steps = [...form.querySelectorAll('[data-contact-step]')];
	const progressFill = form.querySelector('[data-progress-fill]');
	const stepLabel = form.querySelector('[data-step-label]');
	const stepTitle = form.querySelector('[data-step-title]');

	if (steps.length !== STEP_COUNT) return;

	let currentStep = 1;

	const showStep = (stepNum) => {
		currentStep = stepNum;

		for (const step of steps) {
			const isActive = Number(step.dataset.contactStep) === stepNum;
			step.hidden = !isActive;
			step.classList.toggle('is-active', isActive);
		}

		if (progressFill) {
			progressFill.style.width = `${(stepNum / STEP_COUNT) * 100}%`;
		}

		if (stepLabel) {
			stepLabel.textContent = `Step ${stepNum} of ${STEP_COUNT}`;
		}

		if (stepTitle) {
			stepTitle.textContent = STEP_TITLES[stepNum] ?? '';
		}

		const firstField = steps[stepNum - 1]?.querySelector('input, select, textarea');
		firstField?.focus({ preventScroll: true });
	};

	form.addEventListener('click', (event) => {
		const nextButton = event.target.closest('[data-contact-next]');
		const prevButton = event.target.closest('[data-contact-prev]');

		if (nextButton) {
			event.preventDefault();

			if (!validateStepFields(steps[currentStep - 1])) return;
			if (currentStep < STEP_COUNT) showStep(currentStep + 1);
			return;
		}

		if (prevButton) {
			event.preventDefault();
			if (currentStep > 1) showStep(currentStep - 1);
		}
	});

	form.addEventListener('keydown', (event) => {
		if (event.key !== 'Enter') return;
		if (event.target.tagName === 'TEXTAREA' || event.target.tagName === 'SELECT') return;

		const activeStep = steps[currentStep - 1];
		if (!activeStep?.contains(event.target)) return;

		const nextButton = activeStep.querySelector('[data-contact-next]');
		if (!nextButton) return;

		event.preventDefault();
		nextButton.click();
	});

	showStep(1);
}

function initContactForms() {
	for (const island of document.querySelectorAll('is-land[type="contact-form"]')) {
		initAnimationsForElement(island);

		const form = island.querySelector('form[data-contact-form]');
		if (form) initContactForm(form);
	}
}

requestAnimationFrame(initContactForms);
